module.exports = __webpack_public_path__ + "static/media/BrownTS_Personal_Brand.cd82da09.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/aboutme/BrownTS_Personal_Brand.pdf
// module id = 347
// module chunks = 0